import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

interface OptionCheckboxProps {
  title: string;
  checked: boolean;
  onClick: () => void;
}

export const OptionCheckbox = ({ title, checked: initialChecked, onClick }: OptionCheckboxProps) => {
  const [checked, setChecked] = useState<boolean>(initialChecked);

  useEffect(() => {
    if (checked !== initialChecked) {
      setChecked(initialChecked);
    }
  }, [initialChecked]);

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(event, checked) => {
            setChecked(checked);
            onClick();
          }}
        />
      }
      label={
        <Typography
          color="textPrimary"
          sx={{
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      }
    />
  );
};
